import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const AllJournalists = lazy(() => import('./AllJournalists'))

const AllJournalistsRoutes = [
    {
        path: '/all_journalists',
        component: AllJournalists,
        auth: authRoleAccess.allJournalists,
    },
]

export default AllJournalistsRoutes 